export default {
  body: "1.625",
  heading: "1.25"
};
